import { Injectable } from '@angular/core';
import { ModalRef, ModalService } from '../modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingDialogService {
  private isLoading = false;
  private modalRef: ModalRef<void> | null = null;

  constructor(private modalService: ModalService) {}

  async presentLoadingDialog(message: string): Promise<void> {
    this.isLoading = true;
    this.modalRef = await this.modalService.presentLoadingDialog(message);
  }

  async dismissLoadingDialog(): Promise<boolean> {
    // TODO(Ride WSS): Refactor to use material loading dialog or some equivalent
    this.isLoading = false;
    if (this.modalRef) {
      await this.modalRef.dismiss();
      this.modalRef = null;
    }

    return true;
  }
}
